import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { usePeriodo } from '../../contexts/PeriodoContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/ui/table';
import { Badge } from '../../components/ui/badge';
import { 
  Clock, Plus, Loader2, Calendar, 
  Users, AlertTriangle, CheckCircle,
  Download, User, ChevronRight, ChevronLeft,
  AlertCircle, XCircle, Settings, Lock,
  Pencil, Trash2, Eye, FileText, Printer,
  History, Save, RefreshCw
} from 'lucide-react';
import { toast } from 'sonner';
import { Checkbox } from '../../components/ui/checkbox';
import { DialogFooter } from '../../components/ui/dialog';
import DigitacaoRapida from './DigitacaoRapida';
import CartaoPontoManual from './CartaoPontoManual';
import { SortableTableHead, useSortableTable } from '../../components/SortableTableHead';
import ModalAjusteDia from '../../components/ModalAjusteDia';
import ModalEditarApuracaoDia from '../../components/ModalEditarApuracaoDia';

const formatHorasHHMM = (h) => {
  const min = Math.round((Number(h) || 0) * 60);
  return `${String(Math.floor(min / 60)).padStart(2, '0')}:${String(min % 60).padStart(2, '0')}`;
};

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Funções de conversão de data
const formatarDataBR = (dataISO) => {
  // Converte YYYY-MM-DD para DD/MM/AAAA
  if (!dataISO) return '';
  const [ano, mes, dia] = dataISO.split('-');
  return `${dia}/${mes}/${ano}`;
};

const parseDataBR = (dataBR) => {
  // Converte DD/MM/AAAA para YYYY-MM-DD
  if (!dataBR) return '';
  const partes = dataBR.split('/');
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return dataBR; // Retorna como está se não conseguir converter
};

const MarcacoesPage = () => {
  const { user, token } = useAuth();
  const { periodoSelecionado, salvarConfiguracao, refetch: refetchPeriodoGlobal } = usePeriodo();
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ajusteDialogOpen, setAjusteDialogOpen] = useState(false);
  const [configDialogOpen, setConfigDialogOpen] = useState(false);
  const [fechamentoDialogOpen, setFechamentoDialogOpen] = useState(false);
  const [reabrirDialogOpen, setReabrirDialogOpen] = useState(false);
  const [filterDate, setFilterDate] = useState(new Date().toISOString().split('T')[0]);
  const [activeTab, setActiveTab] = useState('marcacoes');
  
  // Hook para ordenação
  const { sortColumn, sortDirection, handleSort, sortData } = useSortableTable('nome', 'asc');
  
  // Aba Marcações - Agrupado por empregado
  const [marcacoesAgrupadas, setMarcacoesAgrupadas] = useState([]);
  const [empregados, setEmpregados] = useState([]);
  
  // Aba Apuração
  const [apuracaoData, setApuracaoData] = useState([]);
  const [apuracaoLoading, setApuracaoLoading] = useState(false);
  const [empregadoSelecionado, setEmpregadoSelecionado] = useState(null);
  const [jornadasEmpregado, setJornadasEmpregado] = useState(null);
  const [jornadasLoading, setJornadasLoading] = useState(false);
  
  // Aba Ajustes RH
  const [ajustesRH, setAjustesRH] = useState([]);
  const [ajustesLoading, setAjustesLoading] = useState(false);
  const [empregadoParaAjuste, setEmpregadoParaAjuste] = useState(null);
  const [detalhesDiaOpen, setDetalhesDiaOpen] = useState(false);
  const [detalhesDia, setDetalhesDia] = useState(null);
  
  // Nova tela de Ajustes RH - Marcações por período
  const [marcacoesPeriodo, setMarcacoesPeriodo] = useState([]);
  const [marcacoesPeriodoLoading, setMarcacoesPeriodoLoading] = useState(false);
  const [showConfirmReprocessar, setShowConfirmReprocessar] = useState(false);
  const [ajustePendente, setAjustePendente] = useState(null);
  const [gerarInconsistencias, setGerarInconsistencias] = useState(true);
  
  // Modal de Ajuste de Dia Completo
  const [modalAjusteOpen, setModalAjusteOpen] = useState(false);
  const [empregadoAjuste, setEmpregadoAjuste] = useState(null);
  const [dataAjuste, setDataAjuste] = useState(null);
  
  // Edição de Jornada na Apuração
  const [editJornadaOpen, setEditJornadaOpen] = useState(false);
  const [jornadaEditando, setJornadaEditando] = useState(null);
  
  // Edição de célula inline (double-click)
  const [editandoCelula, setEditandoCelula] = useState(null);
  const [novaHora, setNovaHora] = useState('');
  const [motivoAjuste, setMotivoAjuste] = useState('');
  
  // Filtro de empregado e recálculo em lote
  const [filtroEmpregadoAjustes, setFiltroEmpregadoAjustes] = useState('todos');
  const [recalculandoJornadas, setRecalculandoJornadas] = useState(false);
  const [showConfirmRecalculo, setShowConfirmRecalculo] = useState(false);
  
  // Exclusão Coletiva de Marcações
  const [exclusaoColetivaOpen, setExclusaoColetivaOpen] = useState(false);
  const [exclusaoLoading, setExclusaoLoading] = useState(false);
  const [exclusaoEmpregadosSelecionados, setExclusaoEmpregadosSelecionados] = useState([]);
  const [exclusaoModo, setExclusaoModo] = useState('periodo'); // 'periodo' ou 'dia'
  const [exclusaoDiaEspecifico, setExclusaoDiaEspecifico] = useState('');
  const [exclusaoJustificativa, setExclusaoJustificativa] = useState('');
  const [exclusaoPreview, setExclusaoPreview] = useState(null);
  
  // Período de Apuração
  const [periodoFechamento, setPeriodoFechamento] = useState(null);
  const [justificativaReabertura, setJustificativaReabertura] = useState('');
  const [configPeriodo, setConfigPeriodo] = useState({
    tipo: 'mes_civil',
    dia_inicio: 1,
    dia_fim: 30
  });
  
  // Form de ajuste de marcação
  const [ajusteForm, setAjusteForm] = useState({
    empregado_id: '',
    data: new Date().toISOString().split('T')[0],
    hora: '',
    hora_original: '', // Hora original clicada para referência
    tipo_ajuste: 'adicionar',
    justificativa: '',
    marcacao_original_id: null
  });
  
  // Formulário nova marcação
  const [formData, setFormData] = useState({
    empregado_id: '',
    data: new Date().toISOString().split('T')[0],
    hora: new Date().toTimeString().slice(0, 5),
    origem: 'manual',
    empresa_id: user?.empresa_id || ''
  });

  const origens = [
    { value: 'rep', label: 'REP' },
    { value: 'facial', label: 'Reconhecimento Facial' },
    { value: 'app', label: 'Aplicativo' },
    { value: 'manual', label: 'Manual' }
  ];

  useEffect(() => {
    fetchEmpregados();
    fetchPeriodoFechamento();
    fetchConfigPeriodo();
  }, []);

  useEffect(() => {
    if (activeTab === 'marcacoes') {
      fetchMarcacoesAgrupadas();
    } else if (activeTab === 'apuracao') {
      if (empregadoSelecionado) {
        fetchJornadasEmpregado(empregadoSelecionado);
      } else {
        fetchApuracao();
      }
    } else if (activeTab === 'ajustes') {
      fetchAjustesRH();
      if (periodoSelecionado) {
        fetchMarcacoesPeriodo();
      }
    }
  }, [filterDate, activeTab, periodoSelecionado]);

  // Carregar configuração do período salva
  const fetchConfigPeriodo = async () => {
    try {
      const res = await fetch(`${API_URL}/api/periodo-apuracao/configuracao`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data.tipo) {
          setConfigPeriodo(data);
        }
      }
    } catch (err) {
      console.error('Erro ao carregar config período:', err);
    }
  };

  const fetchPeriodoFechamento = async () => {
    try {
      const resFech = await fetch(`${API_URL}/api/periodos-fechamento/atual?empresa_id=${user?.empresa_id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (resFech.ok) {
        const dataFech = await resFech.json();
        setPeriodoFechamento(dataFech);
      }
    } catch (err) {
      console.error('Erro ao buscar período de fechamento:', err);
    }
  };

  const handleFecharPeriodo = async () => {
    if (!periodoFechamento) return;
    
    try {
      const res = await fetch(`${API_URL}/api/periodos-fechamento/fechar`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          empresa_id: user?.empresa_id,
          data_inicio: periodoFechamento.data_inicio,
          data_fim: periodoFechamento.data_fim
        })
      });
      
      if (res.ok) {
        toast.success('Período fechado com sucesso');
        setFechamentoDialogOpen(false);
        fetchPeriodoFechamento();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao fechar período');
      }
    } catch (err) {
      toast.error('Erro ao fechar período');
    }
  };

  const handleReabrirPeriodo = async () => {
    if (!periodoFechamento || !justificativaReabertura) {
      toast.error('Informe a justificativa para reabrir o período');
      return;
    }
    
    try {
      const res = await fetch(`${API_URL}/api/periodos-fechamento/reabrir`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          periodo_id: periodoFechamento.id,
          justificativa: justificativaReabertura
        })
      });
      
      if (res.ok) {
        toast.success('Período reaberto para correções');
        setReabrirDialogOpen(false);
        setJustificativaReabertura('');
        fetchPeriodoFechamento();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao reabrir período');
      }
    } catch (err) {
      toast.error('Erro ao reabrir período');
    }
  };

  const fetchMarcacoesAgrupadas = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/marcacoes/agrupado?data=${filterDate}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setMarcacoesAgrupadas(data.empregados || []);
      }
    } catch (err) {
      toast.error('Erro ao carregar marcações');
    } finally {
      setLoading(false);
    }
  };

  const fetchEmpregados = async () => {
    try {
      const res = await fetch(`${API_URL}/api/empregados`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setEmpregados(data || []);
      }
    } catch (err) {
      console.error('Erro ao buscar empregados:', err);
    }
  };

  const fetchApuracao = async () => {
    try {
      setApuracaoLoading(true);
      const res = await fetch(`${API_URL}/api/apuracao-ponto?data=${filterDate}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setApuracaoData(data.apuracao || []);
      }
    } catch (err) {
      toast.error('Erro ao carregar apuração');
    } finally {
      setApuracaoLoading(false);
    }
  };

  const fetchJornadasEmpregado = async (empregadoId) => {
    try {
      setJornadasLoading(true);
      const params = periodoSelecionado 
        ? `data_inicio=${periodoSelecionado.data_inicio}&data_fim=${periodoSelecionado.data_fim}`
        : '';
      const res = await fetch(`${API_URL}/api/apuracao-ponto/empregado/${empregadoId}?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setJornadasEmpregado(data);
      }
    } catch (err) {
      toast.error('Erro ao carregar jornadas');
    } finally {
      setJornadasLoading(false);
    }
  };

  // ==================== EDIÇÃO DE JORNADA NA APURAÇÃO ====================
  const handleEditJornada = (jornada) => {
    setJornadaEditando(jornada);
    setEditJornadaOpen(true);
  };

  const recarregarJornadasApuracao = () => {
    if (jornadasEmpregado?.empregado?.id) fetchJornadasEmpregado(jornadasEmpregado.empregado.id);
  };

  const abrirMarcacoesDoDiaApuracao = () => {
    setEmpregadoAjuste(jornadasEmpregado?.empregado);
    setDataAjuste(jornadaEditando?.data);
    setEditJornadaOpen(false);
    setModalAjusteOpen(true);
  };

  const fetchAjustesRH = async () => {
    try {
      setAjustesLoading(true);
      const res = await fetch(`${API_URL}/api/marcacoes/ajustes-rh?empresa_id=${user?.empresa_id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setAjustesRH(data.ajustes || []);
      }
    } catch (err) {
      toast.error('Erro ao carregar ajustes');
    } finally {
      setAjustesLoading(false);
    }
  };

  // Buscar marcações do período para a nova tela de Ajustes RH
  const fetchMarcacoesPeriodo = async (empregadoIdFiltro = null) => {
    if (!periodoSelecionado) return;
    
    try {
      setMarcacoesPeriodoLoading(true);
      let url = `${API_URL}/api/marcacoes/periodo?empresa_id=${user?.empresa_id}&data_inicio=${periodoSelecionado.data_inicio}&data_fim=${periodoSelecionado.data_fim}`;
      
      // Adicionar filtro de empregado se não for "todos"
      const empId = empregadoIdFiltro !== null ? empregadoIdFiltro : filtroEmpregadoAjustes;
      if (empId && empId !== 'todos') {
        url += `&empregado_id=${empId}`;
      }
      
      const res = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` }});
      if (res.ok) {
        const data = await res.json();
        setMarcacoesPeriodo(data.marcacoes || []);
      }
    } catch (err) {
      toast.error('Erro ao carregar marcações do período');
    } finally {
      setMarcacoesPeriodoLoading(false);
    }
  };

  // Salvar ajuste de marcação com double-click
  const salvarAjusteMarcacao = async () => {
    if (!editandoCelula || !motivoAjuste.trim()) {
      toast.error('Preencha o motivo do ajuste');
      return;
    }

    setAjustePendente({
      empregado_id: editandoCelula.empregado_id,
      empregado_nome: editandoCelula.empregado_nome,
      data: editandoCelula.data,
      slot: editandoCelula.slot,
      hora_original: editandoCelula.hora_original,
      nova_hora: novaHora,
      motivo: motivoAjuste
    });
    setShowConfirmReprocessar(true);
  };

  // Confirmar e executar o ajuste
  const confirmarAjuste = async () => {
    if (!ajustePendente) return;

    try {
      const res = await fetch(`${API_URL}/api/marcacoes/ajuste-rh`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          empregado_id: ajustePendente.empregado_id,
          data: ajustePendente.data,
          hora: ajustePendente.nova_hora,
          hora_original: ajustePendente.hora_original,
          tipo_ajuste: ajustePendente.hora_original ? 'corrigir' : 'adicionar',
          justificativa: ajustePendente.motivo,
          reprocessar_jornada: true,
          gerar_inconsistencias: gerarInconsistencias
        })
      });

      if (res.ok) {
        toast.success('Ajuste salvo com sucesso!');
        setEditandoCelula(null);
        setNovaHora('');
        setMotivoAjuste('');
        setShowConfirmReprocessar(false);
        setAjustePendente(null);
        fetchMarcacoesPeriodo();
        fetchAjustesRH();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao salvar ajuste');
      }
    } catch (err) {
      toast.error('Erro ao salvar ajuste');
    }
  };

  // Abrir modal de ajuste completo do dia
  const handleDoubleClickCelula = (empregado, data, slot, horaAtual) => {
    setEmpregadoAjuste(empregado);
    setDataAjuste(data);
    setModalAjusteOpen(true);
  };

  // Fechar modal e recarregar dados
  const handleModalAjusteClose = () => {
    setModalAjusteOpen(false);
    setEmpregadoAjuste(null);
    setDataAjuste(null);
  };

  // Callback após salvar ajuste
  const handleAjusteSalvo = () => {
    fetchMarcacoesPeriodo();
    fetchAjustesRH();
    if (activeTab === 'apuracao') recarregarJornadasApuracao();
  };

  // Recalcular jornadas em lote
  const recalcularJornadasLote = async () => {
    if (!periodoSelecionado) {
      toast.error('Selecione um período de apuração');
      return;
    }

    try {
      setRecalculandoJornadas(true);
      setShowConfirmRecalculo(false);

      const payload = {
        empresa_id: user?.empresa_id,
        data_inicio: periodoSelecionado.data_inicio,
        data_fim: periodoSelecionado.data_fim,
        empregado_id: filtroEmpregadoAjustes !== 'todos' ? filtroEmpregadoAjustes : null
      };

      const res = await fetch(`${API_URL}/api/jornadas/reprocessar-periodo-lote`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        const data = await res.json();
        toast.success(data.message);
        // Recarregar marcações para atualizar os valores de jornada/HE/Ad.Not
        fetchMarcacoesPeriodo();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao recalcular jornadas');
      }
    } catch (err) {
      toast.error('Erro ao recalcular jornadas');
    } finally {
      setRecalculandoJornadas(false);
    }
  };

  // Ao mudar filtro de empregado, recarregar marcações
  const handleFiltroEmpregadoChange = (value) => {
    setFiltroEmpregadoAjustes(value);
    fetchMarcacoesPeriodo(value);
  };

  const fetchDetalhesDia = async (empregadoId, data) => {
    try {
      const res = await fetch(
        `${API_URL}/api/marcacoes/detalhes-dia?empregado_id=${empregadoId}&data=${data}`,
        { headers: { 'Authorization': `Bearer ${token}` }}
      );
      if (res.ok) {
        const data = await res.json();
        setDetalhesDia(data);
        setDetalhesDiaOpen(true);
      }
    } catch (err) {
      toast.error('Erro ao carregar detalhes');
    }
  };

  const handleCreateMarcacao = async () => {
    try {
      const res = await fetch(`${API_URL}/api/marcacoes`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          empresa_id: user?.empresa_id
        })
      });
      
      if (res.ok) {
        toast.success('Marcação registrada com sucesso');
        setDialogOpen(false);
        fetchMarcacoesAgrupadas();
        setFormData({
          ...formData,
          hora: new Date().toTimeString().slice(0, 5)
        });
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao registrar marcação');
      }
    } catch (err) {
      toast.error('Erro ao registrar marcação');
    }
  };

  const handleCreateAjusteRH = async () => {
    // Validação depende do tipo de ajuste
    const isExclusao = ajusteForm.tipo_ajuste === 'excluir';
    
    if (!ajusteForm.empregado_id || !ajusteForm.justificativa) {
      toast.error('Preencha todos os campos obrigatórios');
      return;
    }
    
    // Para exclusão, a hora original é obrigatória (para identificar qual marcação excluir)
    if (isExclusao && !ajusteForm.hora_original && !ajusteForm.hora) {
      toast.error('Selecione uma marcação para excluir');
      return;
    }
    
    // Para outros tipos, a hora do ajuste é obrigatória
    if (!isExclusao && !ajusteForm.hora) {
      toast.error('Preencha a hora do ajuste');
      return;
    }
    
    if (ajusteForm.justificativa.trim().length < 5) {
      toast.error('Justificativa deve ter pelo menos 5 caracteres');
      return;
    }
    
    try {
      // Enviar data no formato DD/MM/AAAA (o backend aceita ambos formatos)
      const dadosEnvio = {
        ...ajusteForm,
        data: formatarDataBR(ajusteForm.data), // Converte YYYY-MM-DD para DD/MM/AAAA
        // Para exclusão, usar a hora original se não tiver hora ajustada
        hora: ajusteForm.hora || ajusteForm.hora_original
      };
      
      const res = await fetch(`${API_URL}/api/marcacoes/ajuste-rh`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dadosEnvio)
      });
      
      if (res.ok) {
        toast.success(isExclusao ? 'Marcação excluída com sucesso' : 'Ajuste registrado com sucesso');
        setAjusteDialogOpen(false);
        fetchAjustesRH();
        fetchMarcacoesAgrupadas();
        setAjusteForm({
          empregado_id: '',
          data: new Date().toISOString().split('T')[0],
          hora: '',
          hora_original: '',
          tipo_ajuste: 'adicionar',
          justificativa: '',
          marcacao_original_id: null
        });
      } else {
        const err = await res.json();
        // Exibir mensagem de erro de validação do backend
        if (err.detail && Array.isArray(err.detail)) {
          const msgs = err.detail.map(e => e.msg || e.message || JSON.stringify(e)).join('; ');
          toast.error(msgs);
        } else {
          toast.error(err.detail || 'Erro ao registrar ajuste');
        }
      }
    } catch (err) {
      toast.error('Erro ao registrar ajuste');
    }
  };

  // ==================== EXCLUSÃO COLETIVA ====================
  
  const handlePreviewExclusaoColetiva = async () => {
    if (exclusaoEmpregadosSelecionados.length === 0) {
      toast.error('Selecione ao menos um empregado');
      return;
    }
    
    try {
      setExclusaoLoading(true);
      const body = {
        empregado_ids: exclusaoEmpregadosSelecionados,
        data_inicio: periodoSelecionado.data_inicio,
        data_fim: periodoSelecionado.data_fim,
        modo: exclusaoModo,
        dia_especifico: exclusaoModo === 'dia' ? exclusaoDiaEspecifico : null
      };
      
      const res = await fetch(`${API_URL}/api/marcacoes/exclusao-coletiva/preview`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
      
      if (res.ok) {
        const data = await res.json();
        setExclusaoPreview(data);
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao buscar preview');
      }
    } catch (err) {
      toast.error('Erro ao buscar preview');
    } finally {
      setExclusaoLoading(false);
    }
  };
  
  const handleExcluirColetivo = async () => {
    if (!exclusaoJustificativa || exclusaoJustificativa.trim().length < 5) {
      toast.error('Justificativa deve ter no mínimo 5 caracteres');
      return;
    }
    
    try {
      setExclusaoLoading(true);
      const body = {
        empregado_ids: exclusaoEmpregadosSelecionados,
        data_inicio: periodoSelecionado.data_inicio,
        data_fim: periodoSelecionado.data_fim,
        modo: exclusaoModo,
        dia_especifico: exclusaoModo === 'dia' ? exclusaoDiaEspecifico : null,
        justificativa: exclusaoJustificativa
      };
      
      const res = await fetch(`${API_URL}/api/marcacoes/exclusao-coletiva`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
      
      if (res.ok) {
        const data = await res.json();
        toast.success(`${data.total_excluidas} marcações excluídas com sucesso`);
        setExclusaoColetivaOpen(false);
        resetExclusaoColetiva();
        fetchMarcacoesPeriodo();
        fetchAjustesRH();
        fetchMarcacoesAgrupadas();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao excluir marcações');
      }
    } catch (err) {
      toast.error('Erro ao excluir marcações');
    } finally {
      setExclusaoLoading(false);
    }
  };
  
  const resetExclusaoColetiva = () => {
    setExclusaoEmpregadosSelecionados([]);
    setExclusaoModo('periodo');
    setExclusaoDiaEspecifico('');
    setExclusaoJustificativa('');
    setExclusaoPreview(null);
  };
  
  const toggleEmpregadoExclusao = (empId) => {
    setExclusaoEmpregadosSelecionados(prev => {
      if (prev.includes(empId)) {
        return prev.filter(id => id !== empId);
      } else {
        return [...prev, empId];
      }
    });
    setExclusaoPreview(null); // Reset preview ao mudar seleção
  };
  
  const toggleTodosEmpregadosExclusao = () => {
    if (exclusaoEmpregadosSelecionados.length === empregados.length) {
      setExclusaoEmpregadosSelecionados([]);
    } else {
      setExclusaoEmpregadosSelecionados(empregados.map(e => e.id));
    }
    setExclusaoPreview(null);
  };

  const handleDeleteAjuste = async (marcacaoId) => {
    if (!window.confirm('Tem certeza que deseja excluir este ajuste?')) return;
    
    try {
      const res = await fetch(`${API_URL}/api/marcacoes/ajuste-rh/${marcacaoId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (res.ok) {
        toast.success('Ajuste excluído');
        fetchAjustesRH();
        fetchMarcacoesAgrupadas();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Erro ao excluir ajuste');
      }
    } catch (err) {
      toast.error('Erro ao excluir ajuste');
    }
  };

  const handleSaveConfigPeriodo = async () => {
    try {
      const res = await fetch(`${API_URL}/api/periodo-apuracao/configuracao`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...configPeriodo,
          empresa_id: user?.empresa_id
        })
      });
      
      if (res.ok) {
        toast.success('Configuração salva');
        setConfigDialogOpen(false);
        fetchPeriodoFechamento();
        // Atualizar o contexto global de período
        await salvarConfiguracao(configPeriodo);
        refetchPeriodoGlobal();
      } else {
        toast.error('Erro ao salvar configuração');
      }
    } catch (err) {
      toast.error('Erro ao salvar');
    }
  };

  const getStatusBadge = (status) => {
    const configs = {
      'ok': { label: 'OK', variant: 'default', icon: CheckCircle, color: 'bg-emerald-500' },
      'falta': { label: 'Falta', variant: 'destructive', icon: XCircle, color: 'bg-red-500' },
      'incompleto': { label: 'Incompleto', variant: 'secondary', icon: AlertCircle, color: 'bg-amber-500' },
      'atraso': { label: 'Atraso', variant: 'secondary', icon: Clock, color: 'bg-orange-500' },
      'hora_extra': { label: 'H. Extra', variant: 'default', icon: Clock, color: 'bg-blue-500' },
      'pendencia': { label: 'Pendência', variant: 'destructive', icon: AlertTriangle, color: 'bg-red-500' }
    };
    const config = configs[status] || configs['ok'];
    const Icon = config.icon;
    
    return (
      <Badge className={`${config.color} text-white flex items-center gap-1`}>
        <Icon className="w-3 h-3" />
        {config.label}
      </Badge>
    );
  };

  const formatDate = (dateStr, includeWeekday = false) => {
    if (!dateStr) return '-';
    const [year, month, day] = dateStr.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    
    const diasSemana = [
      'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 
      'Quinta-feira', 'Sexta-feira', 'Sábado'
    ];
    
    const formatted = `${day}/${month}/${year}`;
    
    if (includeWeekday) {
      const diaSemana = diasSemana[date.getDay()];
      return `${diaSemana}, ${formatted}`;
    }
    
    return formatted;
  };

  const formatDateShort = (dateStr) => {
    if (!dateStr) return '-';
    const [year, month, day] = dateStr.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    
    const diasSemanaAbrev = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    const diaSemana = diasSemanaAbrev[date.getDay()];
    
    return `${diaSemana}, ${day}/${month}`;
  };

  return (
    <div className="p-6 space-y-6" data-testid="marcacoes-page">
      {/* Header Compacto */}
      <div className="flex items-center justify-between pb-2 border-b border-slate-200">
        <div className="flex items-center gap-4">
          <h1 className="text-xl font-bold text-slate-800">Gestão de Marcações</h1>
          {periodoSelecionado && (
            <Badge variant="outline" className={`text-xs ${
              periodoFechamento?.status === 'fechado' 
                ? 'bg-emerald-50 text-emerald-700 border-emerald-300' 
                : 'bg-slate-50 text-slate-600'
            }`}>
              <Calendar className="w-3 h-3 mr-1" />
              {periodoSelecionado.descricao}
              {periodoFechamento?.status === 'fechado' && (
                <CheckCircle className="w-3 h-3 ml-1 text-emerald-600" />
              )}
            </Badge>
          )}
        </div>
        <div className="flex items-center gap-2">
          {periodoFechamento?.status === 'fechado' ? (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setReabrirDialogOpen(true)}
              className="text-amber-600 border-amber-300 h-8"
            >
              Reabrir Período
            </Button>
          ) : periodoFechamento?.pode_fechar ? (
            <Button
              size="sm"
              onClick={() => setFechamentoDialogOpen(true)}
              className="bg-emerald-500 hover:bg-emerald-600 h-8"
            >
              Fechar Período
            </Button>
          ) : null}
          <Button
            variant="outline"
            size="sm"
            onClick={() => setConfigDialogOpen(true)}
            className="gap-1 h-8"
          >
            <Settings className="w-3.5 h-3.5" />
            Config
          </Button>
          <Button size="sm" onClick={() => setDialogOpen(true)} className="gap-1 h-8">
            <Plus className="w-3.5 h-3.5" />
            Nova Marcação
          </Button>
        </div>
      </div>

      {/* Tabs com Filtro Inline */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="flex items-center justify-between py-2">
          <TabsList className="h-9">
            <TabsTrigger value="marcacoes" className="gap-1.5 text-sm h-7 px-3" data-testid="tab-marcacoes">
              <Clock className="w-3.5 h-3.5" />
              Marcações
            </TabsTrigger>
            <TabsTrigger value="ajustes" className="gap-1.5 text-sm h-7 px-3" data-testid="tab-ajustes">
              <Pencil className="w-3.5 h-3.5" />
              Ajustes RH
            </TabsTrigger>
            <TabsTrigger value="digitacao" className="gap-1.5 text-sm h-7 px-3" data-testid="tab-digitacao">
              <FileText className="w-3.5 h-3.5" />
              Digitação Rápida
            </TabsTrigger>
            <TabsTrigger value="cartao-manual" className="gap-1.5 text-sm h-7 px-3" data-testid="tab-cartao-manual">
              <Printer className="w-3.5 h-3.5" />
              Cartão Manual
            </TabsTrigger>
            <TabsTrigger value="apuracao" className="gap-1.5 text-sm h-7 px-3" data-testid="tab-apuracao">
              <Users className="w-3.5 h-3.5" />
              Apuração
            </TabsTrigger>
          </TabsList>
          
          <div className="flex items-center gap-2">
            <Label className="text-xs text-slate-500">Data:</Label>
            <Input
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              className="w-36 h-8 text-sm"
              data-testid="input-filter-date"
            />
          </div>
        </div>

        {/* Aba Marcações - Layout Otimizado */}
        <TabsContent value="marcacoes" className="mt-0">
          <Card className="border-t-0 rounded-t-none">
            <CardHeader className="py-2 px-4 bg-slate-50 border-b">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-slate-700">
                    {formatDate(filterDate, true)}
                  </span>
                  <span className="text-xs text-slate-400">|</span>
                  <span className="text-xs text-slate-500">
                    {marcacoesAgrupadas.length} empregado(s)
                  </span>
                </div>
                {marcacoesAgrupadas.filter(m => m.tem_inconsistencia).length > 0 && (
                  <Badge variant="destructive" className="text-xs h-5">
                    <AlertTriangle className="w-3 h-3 mr-1" />
                    {marcacoesAgrupadas.filter(m => m.tem_inconsistencia).length} com inconsistências
                  </Badge>
                )}
              </div>
            </CardHeader>
            <CardContent className="p-0">
              {loading ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
                </div>
              ) : marcacoesAgrupadas.length === 0 ? (
                <div className="text-center py-8 text-slate-500">
                  <Clock className="w-10 h-10 mx-auto mb-2 opacity-30" />
                  <p className="text-sm">Nenhuma marcação encontrada</p>
                </div>
              ) : (
                <div className="overflow-auto max-h-[calc(100vh-280px)]">
                  <Table>
                    <TableHeader className="sticky top-0 bg-white z-10">
                      <TableRow className="hover:bg-transparent">
                        <SortableTableHead column="empregado_nome" label="Empregado" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} className="py-2 text-xs font-semibold" />
                        <SortableTableHead column="empregado_matricula" label="Matrícula" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} className="py-2 text-xs font-semibold" />
                        <SortableTableHead column="setor" label="Setor" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} className="py-2 text-xs font-semibold" />
                        <TableHead className="py-2 text-xs font-semibold text-center">Horários</TableHead>
                        <TableHead className="py-2 text-xs font-semibold text-center">Inconsistências</TableHead>
                        <TableHead className="py-2 text-xs font-semibold text-right w-20">Ações</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                    {sortData(marcacoesAgrupadas).map((emp) => (
                      <TableRow 
                        key={emp.empregado_id}
                        className={`${emp.tem_inconsistencia ? 'bg-red-50/50' : ''} hover:bg-slate-50`}
                      >
                        <TableCell className="py-2 font-medium text-sm">
                          <div className="flex items-center gap-1.5">
                            <User className="w-3.5 h-3.5 text-slate-400" />
                            {emp.empregado_nome}
                          </div>
                        </TableCell>
                        <TableCell className="py-2 text-sm text-slate-600">{emp.empregado_matricula || '-'}</TableCell>
                        <TableCell className="py-2 text-sm text-slate-600">{emp.setor || '-'}</TableCell>
                        <TableCell className="py-2 text-center">
                          <div className="flex justify-center gap-1 flex-wrap">
                            {emp.horarios.length === 0 ? (
                              <span className="text-slate-400 text-xs">-</span>
                            ) : (
                              emp.horarios.map((hora, idx) => (
                                <Badge 
                                  key={idx} 
                                  variant="outline" 
                                  className="font-mono text-xs h-5 px-1.5 cursor-pointer hover:bg-blue-50 hover:border-blue-400 transition-colors"
                                  onClick={() => {
                                    setAjusteForm({
                                      ...ajusteForm,
                                      empregado_id: emp.empregado_id,
                                      data: filterDate,
                                      hora: hora,
                                      hora_original: hora,
                                      tipo_ajuste: 'corrigir'
                                    });
                                    setEmpregadoParaAjuste(emp);
                                    setAjusteDialogOpen(true);
                                  }}
                                  title="Clique para ajustar"
                                >
                                  {hora}
                                </Badge>
                              ))
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="py-2 text-center">
                          {emp.inconsistencias.length === 0 ? (
                            <Badge className="bg-emerald-500 text-white text-xs h-5">
                              <CheckCircle className="w-3 h-3 mr-0.5" />
                              OK
                            </Badge>
                          ) : (
                            <div className="flex flex-wrap gap-1 justify-center max-w-[200px]">
                              {emp.inconsistencias.slice(0, 2).map((inc, idx) => (
                                <Badge 
                                  key={idx} 
                                  variant="destructive"
                                  className="text-[10px] h-5 px-1.5"
                                  title={inc.descricao}
                                >
                                  <AlertTriangle className="w-2.5 h-2.5 mr-0.5" />
                                  {inc.descricao.length > 25 ? inc.descricao.substring(0, 22) + '...' : inc.descricao}
                                </Badge>
                              ))}
                              {emp.inconsistencias.length > 2 && (
                                <span className="text-[10px] text-slate-500">
                                  +{emp.inconsistencias.length - 2}
                                </span>
                              )}
                            </div>
                          )}
                        </TableCell>
                        <TableCell className="py-2 text-right">
                          <div className="flex justify-end gap-0.5">
                            <Button
                              variant="ghost"
                              size="sm"
                              className="h-7 w-7 p-0"
                              onClick={() => fetchDetalhesDia(emp.empregado_id, filterDate)}
                              title="Ver detalhes"
                            >
                              <Eye className="w-3.5 h-3.5" />
                            </Button>
                            <Button
                              variant="ghost"
                              size="sm"
                              className="h-7 w-7 p-0"
                              onClick={() => {
                                setAjusteForm({
                                  ...ajusteForm,
                                  empregado_id: emp.empregado_id,
                                  data: filterDate
                                });
                                setEmpregadoParaAjuste(emp);
                                setAjusteDialogOpen(true);
                              }}
                              title="Novo ajuste"
                            >
                              <Pencil className="w-3.5 h-3.5" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Aba Ajustes RH */}
        <TabsContent value="ajustes">
          <Card>
            <CardHeader className="pb-3">
              <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle className="text-lg flex items-center gap-2">
                      <Pencil className="w-5 h-5" />
                      Ajustes de Marcação (RH)
                    </CardTitle>
                    <p className="text-sm text-slate-500 mt-1">
                      Período: {periodoSelecionado ? `${formatDateShort(periodoSelecionado.data_inicio)} a ${formatDateShort(periodoSelecionado.data_fim)}` : 'Não definido'}
                      {' • '}Duplo clique sobre um horário para ajustar
                    </p>
                  </div>
                  <Button 
                    onClick={() => setAjusteDialogOpen(true)}
                    className="gap-2"
                    data-testid="btn-novo-ajuste"
                  >
                    <Plus className="w-4 h-4" />
                    Novo Ajuste
                  </Button>
                  <Button 
                    variant="destructive"
                    onClick={() => setExclusaoColetivaOpen(true)}
                    className="gap-2"
                    data-testid="btn-exclusao-coletiva"
                  >
                    <Trash2 className="w-4 h-4" />
                    Exclusão Coletiva
                  </Button>
                </div>
                
                {/* Filtro de Empregado + Botão Recalcular */}
                <div className="flex items-center gap-3 pt-2 border-t">
                  <div className="flex items-center gap-2">
                    <Label className="text-sm text-slate-600 whitespace-nowrap">Filtrar:</Label>
                    <Select 
                      value={filtroEmpregadoAjustes} 
                      onValueChange={handleFiltroEmpregadoChange}
                    >
                      <SelectTrigger className="w-[220px]" data-testid="select-filtro-empregado-ajustes">
                        <SelectValue placeholder="Todos os empregados" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="todos">Todos os empregados</SelectItem>
                        {empregados.map((emp) => (
                          <SelectItem key={emp.id} value={emp.id}>
                            {emp.nome}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  
                  <Button
                    variant="outline"
                    onClick={() => setShowConfirmRecalculo(true)}
                    disabled={recalculandoJornadas || !periodoSelecionado}
                    className="gap-2"
                    data-testid="btn-recalcular-jornadas"
                  >
                    {recalculandoJornadas ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <RefreshCw className="w-4 h-4" />
                    )}
                    Recalcular Jornadas
                  </Button>
                  
                  {filtroEmpregadoAjustes !== 'todos' && (
                    <Badge variant="secondary" className="text-xs">
                      Filtrado: {empregados.find(e => e.id === filtroEmpregadoAjustes)?.nome || ''}
                    </Badge>
                  )}
                </div>
              </div>
            </CardHeader>
            <CardContent>
              {marcacoesPeriodoLoading ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
                </div>
              ) : !periodoSelecionado ? (
                <div className="text-center py-12 text-slate-500">
                  <Calendar className="w-12 h-12 mx-auto mb-3 opacity-30" />
                  <p>Selecione um período de apuração</p>
                </div>
              ) : marcacoesPeriodo.length === 0 ? (
                <div className="text-center py-12 text-slate-500">
                  <Pencil className="w-12 h-12 mx-auto mb-3 opacity-30" />
                  <p>Nenhuma marcação no período</p>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow className="bg-slate-100">
                        <TableHead className="font-semibold w-40">Empregado</TableHead>
                        <TableHead className="font-semibold w-20">Data</TableHead>
                        <TableHead className="font-semibold text-center w-14">E1</TableHead>
                        <TableHead className="font-semibold text-center w-14">S1</TableHead>
                        <TableHead className="font-semibold text-center w-14">E2</TableHead>
                        <TableHead className="font-semibold text-center w-14">S2</TableHead>
                        <TableHead className="font-semibold text-center w-14">E3</TableHead>
                        <TableHead className="font-semibold text-center w-14">S3</TableHead>
                        <TableHead className="font-semibold text-center w-16 bg-blue-50">Jornada</TableHead>
                        <TableHead className="font-semibold text-center w-14 bg-amber-50">HE</TableHead>
                        <TableHead className="font-semibold text-center w-14 bg-purple-50">Ad.Not</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {marcacoesPeriodo.map((item, idx) => {
                        const empregado = empregados.find(e => e.id === item.empregado_id) || { id: item.empregado_id, nome: item.empregado_nome };
                        const slots = ['entrada1', 'saida1', 'entrada2', 'saida2', 'entrada3', 'saida3'];
                        const slotLabels = ['E1', 'S1', 'E2', 'S2', 'E3', 'S3'];
                        
                        // Formatar horas para exibição
                        const formatHoras = (valor) => {
                          if (!valor || valor === 0) return '-';
                          const horas = Math.floor(valor);
                          const minutos = Math.round((valor - horas) * 60);
                          return minutos > 0 ? `${horas}:${minutos.toString().padStart(2, '0')}` : `${horas}h`;
                        };
                        
                        return (
                          <TableRow key={`${item.empregado_id}-${item.data}-${idx}`} className="hover:bg-slate-50">
                            <TableCell className="font-medium text-sm truncate max-w-[160px]" title={item.empregado_nome}>
                              {item.empregado_nome}
                            </TableCell>
                            <TableCell className="text-xs">
                              {formatDateShort(item.data)}
                            </TableCell>
                            {slots.map((slot, slotIdx) => {
                              const hora = item[slot] || '';
                              
                              return (
                                <TableCell 
                                  key={slot}
                                  className="text-center p-1"
                                >
                                  <div
                                    onDoubleClick={() => handleDoubleClickCelula(empregado, item.data, slot, hora)}
                                    className={`
                                      cursor-pointer px-1 py-1 rounded text-xs font-mono
                                      ${hora ? 'bg-slate-100 hover:bg-blue-100' : 'bg-slate-50 text-slate-400 hover:bg-blue-50'}
                                      transition-colors
                                    `}
                                    title="Clique duplo para ajustar marcações do dia"
                                  >
                                    {hora || '-'}
                                  </div>
                                </TableCell>
                              );
                            })}
                            {/* Colunas de resumo da jornada */}
                            <TableCell className="text-center text-xs font-mono bg-blue-50/50">
                              {formatHoras(item.jornada)}
                            </TableCell>
                            <TableCell className="text-center text-xs font-mono bg-amber-50/50">
                              {formatHoras(item.horas_extras)}
                            </TableCell>
                            <TableCell className="text-center text-xs font-mono bg-purple-50/50">
                              {formatHoras(item.adicional_noturno)}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              )}

              {/* Histórico de ajustes */}
              {ajustesRH.length > 0 && (
                <div className="mt-6">
                  <h4 className="font-medium text-sm mb-3 flex items-center gap-2">
                    <History className="w-4 h-4" />
                    Histórico de Ajustes do Período
                  </h4>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Data</TableHead>
                        <TableHead>Empregado</TableHead>
                        <TableHead>Hora Ajustada</TableHead>
                        <TableHead>Justificativa</TableHead>
                        <TableHead>Autor</TableHead>
                        <TableHead className="text-right">Ações</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {ajustesRH
                        .filter(a => {
                          if (!periodoSelecionado) return true;
                          const dataAjuste = a.data;
                          return dataAjuste >= periodoSelecionado.data_inicio && dataAjuste <= periodoSelecionado.data_fim;
                        })
                        .map((ajuste) => (
                        <TableRow key={ajuste.id}>
                          <TableCell className="font-medium">
                            {formatDateShort(ajuste.data)}
                          </TableCell>
                          <TableCell>
                            <div>
                              <p className="font-medium">{ajuste.empregado_nome}</p>
                              <p className="text-xs text-slate-500">{ajuste.empregado_matricula}</p>
                            </div>
                          </TableCell>
                          <TableCell className="font-mono">
                            {ajuste.hora}
                          </TableCell>
                          <TableCell className="max-w-xs truncate text-sm">
                            {ajuste.ajuste_justificativa}
                          </TableCell>
                          <TableCell className="text-sm">{ajuste.ajuste_autor_nome}</TableCell>
                          <TableCell className="text-right">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => handleDeleteAjuste(ajuste.id)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </CardContent>
          </Card>

          {/* Dialog de confirmação de reprocessamento */}
          <Dialog open={showConfirmReprocessar} onOpenChange={setShowConfirmReprocessar}>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2">
                  <RefreshCw className="w-5 h-5 text-blue-600" />
                  Reprocessar Jornada
                </DialogTitle>
                <DialogDescription>
                  O ajuste será salvo e a jornada do dia será reprocessada.
                </DialogDescription>
              </DialogHeader>
              
              {ajustePendente && (
                <div className="py-4 space-y-3">
                  <div className="bg-slate-50 p-3 rounded-lg text-sm">
                    <p><strong>Empregado:</strong> {ajustePendente.empregado_nome}</p>
                    <p><strong>Data:</strong> {formatDateShort(ajustePendente.data)}</p>
                    <p><strong>Slot:</strong> {ajustePendente.slot.toUpperCase().replace(/(\d)/, ' $1')}</p>
                    {ajustePendente.hora_original && (
                      <p><strong>Hora Original:</strong> {ajustePendente.hora_original}</p>
                    )}
                    <p><strong>Nova Hora:</strong> {ajustePendente.nova_hora}</p>
                    <p><strong>Motivo:</strong> {ajustePendente.motivo}</p>
                  </div>
                  
                  <div className="flex items-center space-x-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <Checkbox 
                      id="gerar-inconsistencias" 
                      checked={gerarInconsistencias}
                      onCheckedChange={setGerarInconsistencias}
                    />
                    <label htmlFor="gerar-inconsistencias" className="text-sm cursor-pointer">
                      Gerar inconsistências novamente após reprocessar
                    </label>
                  </div>
                </div>
              )}

              <DialogFooter>
                <Button variant="outline" onClick={() => setShowConfirmReprocessar(false)}>
                  Cancelar
                </Button>
                <Button onClick={confirmarAjuste}>
                  <CheckCircle className="w-4 h-4 mr-2" />
                  Confirmar Ajuste
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>

          {/* Dialog de confirmação de recálculo em lote */}
          <Dialog open={showConfirmRecalculo} onOpenChange={setShowConfirmRecalculo}>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2">
                  <RefreshCw className="w-5 h-5 text-blue-600" />
                  Recalcular Jornadas
                </DialogTitle>
                <DialogDescription>
                  As jornadas serão reprocessadas com base nas marcações e configurações atuais (escalas, faixas de HE, período noturno, etc.)
                </DialogDescription>
              </DialogHeader>
              
              <div className="py-4 space-y-3">
                <div className="bg-slate-50 p-3 rounded-lg text-sm space-y-1">
                  <p><strong>Período:</strong> {periodoSelecionado ? `${formatDateShort(periodoSelecionado.data_inicio)} a ${formatDateShort(periodoSelecionado.data_fim)}` : '-'}</p>
                  <p><strong>Empregados:</strong> {filtroEmpregadoAjustes === 'todos' 
                    ? 'Todos os empregados com marcações' 
                    : empregados.find(e => e.id === filtroEmpregadoAjustes)?.nome || '-'
                  }</p>
                </div>
                
                <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                  <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-sm text-amber-700">
                    Esta operação irá sobrescrever as jornadas existentes. 
                    {filtroEmpregadoAjustes === 'todos' && ' Pode levar alguns segundos dependendo da quantidade de registros.'}
                  </p>
                </div>
              </div>

              <DialogFooter>
                <Button variant="outline" onClick={() => setShowConfirmRecalculo(false)}>
                  Cancelar
                </Button>
                <Button onClick={recalcularJornadasLote} disabled={recalculandoJornadas}>
                  {recalculandoJornadas ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <RefreshCw className="w-4 h-4 mr-2" />
                  )}
                  Recalcular
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* Aba Digitação Rápida */}
        <TabsContent value="digitacao" className="mt-0">
          <DigitacaoRapida 
            token={token} 
            empresaId={user?.empresa_id} 
            empregados={empregados}
          />
        </TabsContent>

        {/* Aba Cartão Manual */}
        <TabsContent value="cartao-manual" className="mt-0">
          <CartaoPontoManual token={token} />
        </TabsContent>

        {/* Aba Apuração */}
        <TabsContent value="apuracao">
          {empregadoSelecionado && jornadasEmpregado ? (
            <Card>
              <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <Button 
                      variant="ghost" 
                      size="sm"
                      onClick={() => {
                        setEmpregadoSelecionado(null);
                        setJornadasEmpregado(null);
                        fetchApuracao();
                      }}
                    >
                      <ChevronLeft className="w-4 h-4 mr-1" />
                      Voltar
                    </Button>
                    <div>
                      <CardTitle className="text-lg">
                        {jornadasEmpregado.empregado.nome}
                      </CardTitle>
                      <p className="text-sm text-slate-500">
                        {jornadasEmpregado.empregado.matricula} • {jornadasEmpregado.empregado.cargo}
                      </p>
                    </div>
                  </div>
                  <Button variant="outline" className="gap-2">
                    <Download className="w-4 h-4" />
                    Exportar
                  </Button>
                </div>
              </CardHeader>
              <CardContent>
                {/* Resumo do Período */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                  <Card className="bg-slate-50">
                    <CardContent className="pt-4">
                      <p className="text-xs text-slate-500">Dias Trabalhados</p>
                      <p className="text-2xl font-bold">{jornadasEmpregado.resumo.dias_trabalhados}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-blue-50">
                    <CardContent className="pt-4">
                      <p className="text-xs text-slate-500">Total Horas</p>
                      <p className="text-2xl font-bold text-blue-600">{jornadasEmpregado.resumo.total_horas}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-amber-50">
                    <CardContent className="pt-4">
                      <p className="text-xs text-slate-500">Horas Extras</p>
                      <p className="text-2xl font-bold text-amber-600">{jornadasEmpregado.resumo.total_extras}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-purple-50">
                    <CardContent className="pt-4">
                      <p className="text-xs text-slate-500">Saldo Banco</p>
                      <p className="text-2xl font-bold text-purple-600">{jornadasEmpregado.resumo.saldo_banco_horas}</p>
                    </CardContent>
                  </Card>
                </div>

                {jornadasLoading ? (
                  <div className="flex items-center justify-center py-12">
                    <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Data</TableHead>
                        <TableHead>Tipo Dia</TableHead>
                        <TableHead>Entrada</TableHead>
                        <TableHead>Saída Int.</TableHead>
                        <TableHead>Ret. Int.</TableHead>
                        <TableHead>Saída</TableHead>
                        <TableHead>Trabalhado</TableHead>
                        <TableHead>Extras</TableHead>
                        <TableHead>DSR</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead className="text-right">Ações</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {jornadasEmpregado.jornadas.map((jornada, idx) => (
                        <TableRow 
                          key={idx}
                          className={jornada.status !== 'ok' ? 'bg-amber-50/50' : ''}
                        >
                          <TableCell className="font-medium">
                            {formatDateShort(jornada.data)}
                          </TableCell>
                          <TableCell>
                            <Badge variant="outline" className={
                              jornada.tipo_dia === 'folga' ? 'bg-green-50 text-green-700' :
                              jornada.tipo_dia === 'compensado' ? 'bg-blue-50 text-blue-700' :
                              jornada.tipo_dia === 'feriado' ? 'bg-purple-50 text-purple-700' :
                              'bg-slate-50'
                            }>
                              {jornada.tipo_dia || 'normal'}
                            </Badge>
                            {jornada.ajuste_apuracao && (
                              <Badge variant="outline" className="ml-1 bg-amber-50 text-amber-700 border-amber-300 text-[10px]"
                                title={jornada.ajuste_apuracao.observacao || 'Ajuste manual'} data-testid={`badge-ajuste-manual-${idx}`}>
                                {jornada.falta_abonada ? 'Ajustado · abonado' : 'Ajustado'}
                              </Badge>
                            )}
                          </TableCell>
                          <TableCell className="font-mono">{jornada.entrada || '-'}</TableCell>
                          <TableCell className="font-mono">{jornada.saida_intervalo || '-'}</TableCell>
                          <TableCell className="font-mono">{jornada.retorno_intervalo || '-'}</TableCell>
                          <TableCell className="font-mono">{jornada.saida || '-'}</TableCell>
                          <TableCell className="font-mono">{jornada.horas_trabalhadas || '-'}</TableCell>
                          <TableCell className="font-mono">
                            {jornada.horas_extras > 0 ? `${jornada.horas_extras}h` : '-'}
                          </TableCell>
                          <TableCell className="font-mono" data-testid={`apuracao-dsr-${idx}`}>
                            {jornada.horas_dsr > 0 ? formatHorasHHMM(jornada.horas_dsr) : (jornada.dsr_perdido ? <span className="text-red-600" title="DSR perdido por falta injustificada na semana">Perdido</span> : '-')}
                          </TableCell>
                          <TableCell>{getStatusBadge(jornada.status)}</TableCell>
                          <TableCell className="text-right">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => handleEditJornada(jornada)}
                              title="Editar jornada do dia"
                              data-testid={`btn-edit-jornada-${idx}`}
                            >
                              <Pencil className="w-4 h-4" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          ) : (
            <Card>
              <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg flex items-center gap-2">
                    <Users className="w-5 h-5" />
                    Apuração Geral - {formatDate(filterDate, true)}
                  </CardTitle>
                  <Button variant="outline" className="gap-2">
                    <Download className="w-4 h-4" />
                    Exportar
                  </Button>
                </div>
              </CardHeader>
              <CardContent>
                {apuracaoLoading ? (
                  <div className="flex items-center justify-center py-12">
                    <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
                  </div>
                ) : apuracaoData.length === 0 ? (
                  <div className="text-center py-12 text-slate-500">
                    <Users className="w-12 h-12 mx-auto mb-3 opacity-30" />
                    <p>Nenhum empregado encontrado</p>
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Empregado</TableHead>
                        <TableHead>Entrada</TableHead>
                        <TableHead>Saída Int.</TableHead>
                        <TableHead>Ret. Int.</TableHead>
                        <TableHead>Saída</TableHead>
                        <TableHead>Trabalhado</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {apuracaoData.map((emp) => (
                        <TableRow 
                          key={emp.empregado_id}
                          className={emp.status !== 'ok' ? 'bg-amber-50/50 hover:bg-amber-100/50' : 'hover:bg-slate-50'}
                        >
                          <TableCell>
                            <div className="font-medium">{emp.empregado_nome}</div>
                            <div className="text-xs text-slate-500">{emp.empregado_matricula}</div>
                          </TableCell>
                          <TableCell className="font-mono">{emp.entrada || '-'}</TableCell>
                          <TableCell className="font-mono">{emp.saida_intervalo || '-'}</TableCell>
                          <TableCell className="font-mono">{emp.retorno_intervalo || '-'}</TableCell>
                          <TableCell className="font-mono">{emp.saida || '-'}</TableCell>
                          <TableCell className="font-mono">{emp.horas_trabalhadas || '-'}</TableCell>
                          <TableCell>{getStatusBadge(emp.status)}</TableCell>
                          <TableCell>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => {
                                setEmpregadoSelecionado(emp.empregado_id);
                                fetchJornadasEmpregado(emp.empregado_id);
                              }}
                            >
                              <ChevronRight className="w-4 h-4" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          )}
        </TabsContent>
      </Tabs>

      {/* Dialog Nova Marcação */}
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Nova Marcação</DialogTitle>
            <DialogDescription>
              Registre uma marcação manual de ponto
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Empregado</Label>
              <Select
                value={formData.empregado_id}
                onValueChange={(v) => setFormData({...formData, empregado_id: v})}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Selecione..." />
                </SelectTrigger>
                <SelectContent>
                  {empregados.map((emp) => (
                    <SelectItem key={emp.id} value={emp.id}>
                      {emp.nome} ({emp.matricula || 'S/M'})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Data</Label>
                <Input
                  type="date"
                  value={formData.data}
                  onChange={(e) => setFormData({...formData, data: e.target.value})}
                />
              </div>
              <div>
                <Label>Hora</Label>
                <Input
                  type="time"
                  value={formData.hora}
                  onChange={(e) => setFormData({...formData, hora: e.target.value})}
                />
              </div>
            </div>

            <div>
              <Label>Origem</Label>
              <Select
                value={formData.origem}
                onValueChange={(v) => setFormData({...formData, origem: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {origens.map((o) => (
                    <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline" onClick={() => setDialogOpen(false)}>
                Cancelar
              </Button>
              <Button 
                onClick={handleCreateMarcacao}
                disabled={!formData.empregado_id}
              >
                Registrar
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Ajuste RH */}
      <Dialog open={ajusteDialogOpen} onOpenChange={(open) => {
        setAjusteDialogOpen(open);
        if (!open) {
          // Limpar hora_original ao fechar
          setAjusteForm(prev => ({...prev, hora_original: ''}));
        }
      }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {ajusteForm.hora_original 
                ? `Ajuste de Marcação - ${ajusteForm.hora_original}` 
                : 'Ajuste de Marcação (RH)'}
            </DialogTitle>
            <DialogDescription>
              {ajusteForm.hora_original 
                ? `Você está ajustando a marcação das ${ajusteForm.hora_original}. A marcação original será preservada.`
                : 'Crie um ajuste de marcação. A marcação original será preservada.'}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            {ajusteForm.hora_original && (
              <Card className="bg-blue-50 border-blue-200">
                <CardContent className="py-3">
                  <div className="flex items-start gap-2">
                    <Clock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                    <div className="text-sm text-blue-800">
                      <strong>Marcação Original:</strong> {ajusteForm.hora_original}
                      <br />
                      <span className="text-xs text-blue-600">
                        Empregado: {empregadoParaAjuste?.empregado_nome || 'N/A'}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
            
            <Card className="bg-amber-50 border-amber-200">
              <CardContent className="py-3">
                <div className="flex items-start gap-2">
                  <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-amber-800">
                    <strong>REGRA DE OURO:</strong> Marcações do Totem/AFD nunca são alteradas. 
                    Este ajuste criará um novo registro vinculado ao original.
                  </p>
                </div>
              </CardContent>
            </Card>

            <div>
              <Label>Empregado</Label>
              <Select
                value={ajusteForm.empregado_id}
                onValueChange={(v) => setAjusteForm({...ajusteForm, empregado_id: v})}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Selecione..." />
                </SelectTrigger>
                <SelectContent>
                  {empregados.map((emp) => (
                    <SelectItem key={emp.id} value={emp.id}>
                      {emp.nome} ({emp.matricula || 'S/M'})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Data</Label>
                <Input
                  type="date"
                  value={ajusteForm.data}
                  onChange={(e) => setAjusteForm({...ajusteForm, data: e.target.value})}
                />
              </div>
              <div>
                <Label>{ajusteForm.hora_original ? 'Nova Hora (Ajustada)' : 'Hora do Ajuste'}</Label>
                <Input
                  type="time"
                  value={ajusteForm.hora}
                  onChange={(e) => setAjusteForm({...ajusteForm, hora: e.target.value})}
                  data-testid="input-hora-ajuste"
                />
              </div>
            </div>

            <div>
              <Label>Tipo de Ajuste</Label>
              <Select
                value={ajusteForm.tipo_ajuste}
                onValueChange={(v) => setAjusteForm({...ajusteForm, tipo_ajuste: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="adicionar">Adicionar Marcação</SelectItem>
                  <SelectItem value="corrigir">Corrigir Horário</SelectItem>
                  <SelectItem value="substituir">Substituir Marcação</SelectItem>
                  <SelectItem value="excluir" className="text-red-600">
                    Excluir Marcação
                  </SelectItem>
                </SelectContent>
              </Select>
              {ajusteForm.tipo_ajuste === 'excluir' && (
                <p className="text-xs text-red-600 mt-1">
                  ⚠️ A marcação será inativada (não deletada fisicamente)
                </p>
              )}
            </div>

            <div>
              <Label>Justificativa *</Label>
              <Textarea
                value={ajusteForm.justificativa}
                onChange={(e) => setAjusteForm({...ajusteForm, justificativa: e.target.value})}
                placeholder="Descreva o motivo do ajuste..."
                rows={3}
                data-testid="input-justificativa-ajuste"
              />
            </div>

            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline" onClick={() => setAjusteDialogOpen(false)}>
                Cancelar
              </Button>
              <Button 
                onClick={handleCreateAjusteRH}
                disabled={
                  !ajusteForm.empregado_id || 
                  !ajusteForm.justificativa ||
                  (ajusteForm.tipo_ajuste !== 'excluir' && !ajusteForm.hora)
                }
                className={ajusteForm.tipo_ajuste === 'excluir' ? 'bg-red-600 hover:bg-red-700' : ''}
                data-testid="btn-confirmar-ajuste"
              >
                {ajusteForm.tipo_ajuste === 'excluir' ? 'Confirmar Exclusão' : 'Confirmar Ajuste'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Detalhes do Dia */}
      <Dialog open={detalhesDiaOpen} onOpenChange={setDetalhesDiaOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Detalhes das Marcações</DialogTitle>
            <DialogDescription>
              {detalhesDia?.empregado?.nome} - {formatDate(detalhesDia?.data, true)}
            </DialogDescription>
          </DialogHeader>
          
          {detalhesDia && (
            <div className="space-y-4">
              {/* Marcações Originais */}
              <div>
                <h4 className="font-medium text-slate-700 mb-2 flex items-center gap-2">
                  <Lock className="w-4 h-4" />
                  Marcações Originais (Imutáveis)
                </h4>
                {detalhesDia.marcacoes_originais.length === 0 ? (
                  <p className="text-sm text-slate-500">Nenhuma marcação original</p>
                ) : (
                  <div className="space-y-2">
                    {detalhesDia.marcacoes_originais.map((m, idx) => (
                      <div key={idx} className="flex items-center justify-between bg-slate-50 p-3 rounded-lg">
                        <div className="flex items-center gap-3">
                          <Badge variant="outline" className="font-mono text-lg">
                            {m.hora}
                          </Badge>
                          <span className="text-sm text-slate-500">
                            Origem: {m.origem || 'N/A'}
                          </span>
                        </div>
                        <Badge className="bg-slate-200 text-slate-600">
                          <Lock className="w-3 h-3 mr-1" />
                          Imutável
                        </Badge>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Ajustes RH */}
              <div>
                <h4 className="font-medium text-slate-700 mb-2 flex items-center gap-2">
                  <Pencil className="w-4 h-4" />
                  Ajustes do RH
                </h4>
                {detalhesDia.ajustes_rh.length === 0 ? (
                  <p className="text-sm text-slate-500">Nenhum ajuste registrado</p>
                ) : (
                  <div className="space-y-2">
                    {detalhesDia.ajustes_rh.map((m, idx) => (
                      <div key={idx} className="flex items-center justify-between bg-blue-50 p-3 rounded-lg">
                        <div className="flex items-center gap-3">
                          <Badge className="bg-blue-500 text-white font-mono text-lg">
                            {m.hora}
                          </Badge>
                          <div>
                            <p className="text-sm text-slate-600">{m.ajuste_justificativa}</p>
                            <p className="text-xs text-slate-400">
                              Por: {m.ajuste_autor_nome}
                            </p>
                          </div>
                        </div>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleDeleteAjuste(m.id)}
                          className="text-red-500"
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Jornada Processada */}
              {detalhesDia.jornada && (
                <div className="bg-slate-100 p-4 rounded-lg">
                  <h4 className="font-medium text-slate-700 mb-2">Jornada Processada</h4>
                  <div className="grid grid-cols-4 gap-4 text-sm">
                    <div>
                      <span className="text-slate-500">Entrada</span>
                      <p className="font-mono">{detalhesDia.jornada.entrada || '-'}</p>
                    </div>
                    <div>
                      <span className="text-slate-500">Saída Int.</span>
                      <p className="font-mono">{detalhesDia.jornada.saida_intervalo || '-'}</p>
                    </div>
                    <div>
                      <span className="text-slate-500">Ret. Int.</span>
                      <p className="font-mono">{detalhesDia.jornada.retorno_intervalo || '-'}</p>
                    </div>
                    <div>
                      <span className="text-slate-500">Saída</span>
                      <p className="font-mono">{detalhesDia.jornada.saida || '-'}</p>
                    </div>
                  </div>
                  <div className="mt-3 flex gap-4">
                    <Badge variant="outline">
                      Trabalhado: {detalhesDia.jornada.horas_trabalhadas || 0}h
                    </Badge>
                    {detalhesDia.jornada.horas_extras > 0 && (
                      <Badge className="bg-amber-500">
                        Extras: {detalhesDia.jornada.horas_extras}h
                      </Badge>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Configuração Período */}
      <Dialog open={configDialogOpen} onOpenChange={setConfigDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Configurar Período de Apuração</DialogTitle>
            <DialogDescription>
              Define o ciclo de fechamento do ponto
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Tipo de Período</Label>
              <Select
                value={configPeriodo.tipo}
                onValueChange={(v) => setConfigPeriodo({...configPeriodo, tipo: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="mes_civil">Mês Civil (1 a 30/31)</SelectItem>
                  <SelectItem value="personalizado">Personalizado</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {configPeriodo.tipo === 'personalizado' && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Dia de Início</Label>
                  <Input
                    type="number"
                    min={1}
                    max={28}
                    value={configPeriodo.dia_inicio}
                    onChange={(e) => setConfigPeriodo({...configPeriodo, dia_inicio: parseInt(e.target.value)})}
                  />
                </div>
                <div>
                  <Label>Dia de Fim</Label>
                  <Input
                    type="number"
                    min={1}
                    max={31}
                    value={configPeriodo.dia_fim}
                    onChange={(e) => setConfigPeriodo({...configPeriodo, dia_fim: parseInt(e.target.value)})}
                  />
                </div>
              </div>
            )}

            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline" onClick={() => setConfigDialogOpen(false)}>
                Cancelar
              </Button>
              <Button onClick={handleSaveConfigPeriodo}>
                Salvar
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Fechamento de Período */}
      <Dialog open={fechamentoDialogOpen} onOpenChange={setFechamentoDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Fechar Período de Apuração</DialogTitle>
            <DialogDescription>
              Após o fechamento, as marcações deste período não poderão ser editadas.
            </DialogDescription>
          </DialogHeader>
          
          {periodoFechamento && (
            <div className="space-y-4">
              <Card className="bg-slate-50">
                <CardContent className="pt-4 space-y-2">
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Período:</span>
                    <span className="font-medium">{periodoSelecionado?.descricao}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Empregados:</span>
                    <span className="font-medium">{periodoFechamento.total_empregados}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Horas Trabalhadas:</span>
                    <span className="font-medium">{periodoFechamento.total_horas_trabalhadas}h</span>
                  </div>
                </CardContent>
              </Card>

              <div className="flex justify-end gap-2 pt-4">
                <Button variant="outline" onClick={() => setFechamentoDialogOpen(false)}>
                  Cancelar
                </Button>
                <Button onClick={handleFecharPeriodo} className="bg-emerald-500 hover:bg-emerald-600">
                  <CheckCircle className="w-4 h-4 mr-2" />
                  Confirmar Fechamento
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Reabertura de Período */}
      <Dialog open={reabrirDialogOpen} onOpenChange={setReabrirDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Reabrir Período para Correções</DialogTitle>
            <DialogDescription>
              Informe o motivo para reabrir este período fechado.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Justificativa *</Label>
              <Textarea
                value={justificativaReabertura}
                onChange={(e) => setJustificativaReabertura(e.target.value)}
                placeholder="Descreva o motivo da reabertura (mínimo 10 caracteres)"
                rows={3}
              />
            </div>

            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline" onClick={() => {
                setReabrirDialogOpen(false);
                setJustificativaReabertura('');
              }}>
                Cancelar
              </Button>
              <Button 
                onClick={handleReabrirPeriodo}
                disabled={justificativaReabertura.length < 10}
                className="bg-amber-500 hover:bg-amber-600"
              >
                Reabrir Período
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Ajuste Completo do Dia */}
      <ModalEditarApuracaoDia
        open={editJornadaOpen}
        onClose={() => setEditJornadaOpen(false)}
        empregado={jornadasEmpregado?.empregado}
        jornada={jornadaEditando}
        periodo={jornadasEmpregado?.periodo}
        token={token}
        onSaved={recarregarJornadasApuracao}
        onEditarMarcacoes={abrirMarcacoesDoDiaApuracao}
      />

      <ModalAjusteDia
        open={modalAjusteOpen}
        onClose={handleModalAjusteClose}
        empregado={empregadoAjuste}
        data={dataAjuste}
        token={token}
        empresaId={user?.empresa_id}
        onSave={handleAjusteSalvo}
      />

      {/* Modal de Exclusão Coletiva */}
      <Dialog open={exclusaoColetivaOpen} onOpenChange={(open) => {
        setExclusaoColetivaOpen(open);
        if (!open) resetExclusaoColetiva();
      }}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="w-5 h-5" />
              Exclusão Coletiva de Marcações
            </DialogTitle>
            <DialogDescription>
              Exclua marcações de múltiplos empregados para o período selecionado.
              Esta ação não pode ser desfeita.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Período */}
            <div className="p-3 bg-slate-100 rounded-lg">
              <p className="text-sm text-slate-600">
                <strong>Período:</strong> {periodoSelecionado ? 
                  `${formatDateShort(periodoSelecionado.data_inicio)} a ${formatDateShort(periodoSelecionado.data_fim)}` : 
                  'Não definido'}
              </p>
            </div>

            {/* Modo de exclusão */}
            <div className="space-y-2">
              <Label>Modo de exclusão</Label>
              <Select value={exclusaoModo} onValueChange={(v) => {
                setExclusaoModo(v);
                setExclusaoPreview(null);
              }}>
                <SelectTrigger data-testid="select-modo-exclusao">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="periodo">Todo o período selecionado</SelectItem>
                  <SelectItem value="dia">Dia específico</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Dia específico (se modo=dia) */}
            {exclusaoModo === 'dia' && (
              <div className="space-y-2">
                <Label>Dia específico</Label>
                <Input
                  type="date"
                  value={exclusaoDiaEspecifico}
                  onChange={(e) => {
                    setExclusaoDiaEspecifico(e.target.value);
                    setExclusaoPreview(null);
                  }}
                  min={periodoSelecionado?.data_inicio}
                  max={periodoSelecionado?.data_fim}
                  data-testid="input-dia-exclusao"
                />
              </div>
            )}

            {/* Seleção de empregados */}
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <Label>Selecionar empregados</Label>
                <Button 
                  variant="link" 
                  size="sm" 
                  onClick={toggleTodosEmpregadosExclusao}
                  className="text-xs"
                >
                  {exclusaoEmpregadosSelecionados.length === empregados.length ? 
                    'Desmarcar todos' : 'Selecionar todos'}
                </Button>
              </div>
              
              <div className="border rounded-lg max-h-48 overflow-y-auto">
                {empregados.map((emp) => (
                  <div 
                    key={emp.id}
                    className="flex items-center gap-2 p-2 hover:bg-slate-50 cursor-pointer border-b last:border-b-0"
                    onClick={() => toggleEmpregadoExclusao(emp.id)}
                  >
                    <Checkbox
                      checked={exclusaoEmpregadosSelecionados.includes(emp.id)}
                      data-testid={`checkbox-emp-${emp.id}`}
                    />
                    <span className="text-sm">{emp.nome}</span>
                  </div>
                ))}
              </div>
              <p className="text-xs text-slate-500">
                {exclusaoEmpregadosSelecionados.length} empregado(s) selecionado(s)
              </p>
            </div>

            {/* Botão Preview */}
            <Button
              variant="outline"
              onClick={handlePreviewExclusaoColetiva}
              disabled={exclusaoLoading || exclusaoEmpregadosSelecionados.length === 0 || (exclusaoModo === 'dia' && !exclusaoDiaEspecifico)}
              className="w-full gap-2"
              data-testid="btn-preview-exclusao"
            >
              {exclusaoLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Eye className="w-4 h-4" />}
              Ver Preview
            </Button>

            {/* Preview */}
            {exclusaoPreview && (
              <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg space-y-3">
                <div className="flex items-center gap-2 text-amber-700 font-medium">
                  <AlertTriangle className="w-5 h-5" />
                  Preview da Exclusão
                </div>
                
                <div className="text-sm space-y-1">
                  <p><strong>Total de marcações:</strong> {exclusaoPreview.total_marcacoes}</p>
                  <p><strong>Empregados afetados:</strong> {exclusaoPreview.total_empregados}</p>
                  <p><strong>Período:</strong> {formatDateShort(exclusaoPreview.data_inicio)} a {formatDateShort(exclusaoPreview.data_fim)}</p>
                </div>

                {exclusaoPreview.preview.length > 0 && (
                  <div className="mt-2">
                    <p className="text-sm font-medium mb-1">Detalhamento:</p>
                    <div className="max-h-32 overflow-y-auto text-xs space-y-1">
                      {exclusaoPreview.preview.map((item) => (
                        <div key={item.empregado_id} className="flex justify-between bg-white p-1 rounded">
                          <span>{item.empregado_nome}</span>
                          <span className="text-slate-500">{item.qtd_marcacoes} marcações em {item.qtd_dias} dia(s)</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Justificativa */}
            {exclusaoPreview && exclusaoPreview.total_marcacoes > 0 && (
              <div className="space-y-2">
                <Label>Justificativa obrigatória *</Label>
                <Textarea
                  value={exclusaoJustificativa}
                  onChange={(e) => setExclusaoJustificativa(e.target.value)}
                  placeholder="Descreva o motivo da exclusão coletiva (mínimo 5 caracteres)"
                  rows={3}
                  data-testid="textarea-justificativa-exclusao"
                />
              </div>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setExclusaoColetivaOpen(false);
              resetExclusaoColetiva();
            }}>
              Cancelar
            </Button>
            <Button
              variant="destructive"
              onClick={handleExcluirColetivo}
              disabled={exclusaoLoading || !exclusaoPreview || exclusaoPreview.total_marcacoes === 0 || exclusaoJustificativa.trim().length < 5}
              className="gap-2"
              data-testid="btn-confirmar-exclusao"
            >
              {exclusaoLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
              Excluir {exclusaoPreview?.total_marcacoes || 0} Marcações
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MarcacoesPage;
